import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './student-empty-list.scss';
import SvgIcon from '../../components/svg-icon/svg-icon';

const StudentEmptyList = ({ type, text = null, wholeClass = true }) => (
    <div className={css['inner-svg-empty']}>
        <div className={wholeClass ? `${css['circle-background-empty']} ${css['whole-class']}` :
            css['circle-background-empty']}>
            <SvgIcon
                type="student-management"
            />
        </div>
        {wholeClass ? <div className={`${css['inner-text-empty']} text`}>
            {type}
        </div> : <div className={`label label-default ${css['inner-text-empty']} ${css['text-background']}`}>
            {type}
        </div>}
        {text ? <p style={{ whiteSpace: 'nowrap' }}>{text}</p> : null}
    </div>
);

StudentEmptyList.propTypes = {
    type: PropTypes.object,
    text: PropTypes.string,
    wholeClass: PropTypes.bool
};

export default styleable(css)(StudentEmptyList);



// WEBPACK FOOTER //
// ./components/student-empty-list/student-empty-list.js